import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';


const GiftboxComponent = lazy(() => import('../../pages/Giftbox/containers/GiftboxPageContainer'));
const GiftboxPointHistoryComponent = lazy(() => import('../../pages/Giftbox/containers/GiftboxPointHistoryPageContainer'));
const IframeComponent = lazy(() => import('../../commons/components/IframePage/IframeComponent'));

const route = [
  {
    path: ROUTERS.GIFTBOX_POINT,
    title: 'Giftbox',
    exact: true,
    public: false,
    component: <GiftboxComponent />,
  },
  {
    path: ROUTERS.GIFTBOX_POINT_HISTORY,
    title: 'Giftbox Poit History',
    exact: true,
    public: false,
    component: <GiftboxPointHistoryComponent />,
  },
  {
    path: ROUTERS.IFRAME,
    title: 'Iframe',
    exact: true,
    public: false,
    component: <IframeComponent />,
  },
];

export default route;